import { render, staticRenderFns } from "./EmpresasView.vue?vue&type=template&id=44a84f15&"
import script from "./EmpresasView.vue?vue&type=script&lang=js&"
export * from "./EmpresasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports